export const GET_ERRORS = 'GET_ERRORS';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const UPDATE_PROFILE_IMAGE = 'UPDATE_PROFILE_IMAGE';